<template>

<core-panel>

	<template v-slot:head>

		<h1>Win Rate</h1>

		<p>Win rate across all <b>{{ items.length }}</b> attributes from this game.</p>

	</template>

	<template v-slot:body>

		<div class="winrate-row" v-for="(item, index) in items" :key="index" v-on:click="onSelect(item)" v-tooltip="'View ' + item.name + ' games'">

			<div class="winrate-row-head">

				<div class="winrate-row-name">{{ item.name }}<span class="winrate-row-type">{{ item.type }}</span></div>

				<div class="winrate-row-rate">{{ item.rate }}%</div>

			</div>

			<div class="winrate-row-meta">

				<span class="winrate-row-delta" :class="deltaClass(item.delta)" v-if="item.delta !== null">{{ item.delta > 0 ? '+' : '' }}{{ item.delta }}%</span>

				<span class="winrate-row-record">{{ item.wins }}W / {{ item.total - item.wins }}L</span>

			</div>

			<div class="winrate-row-bar">

				<div class="winrate-row-bar-fill" :class="barClass(item.rate)" :style="{ width: item.rate + '%' }" />

			</div>

		</div>

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'affinity',
			items: []
		}

	},

	methods: {

		response: function(json) {

			this.items = json.affinity.winRates

		},

		deltaClass: function(delta) {

			if (delta > 3) return 'is-positive'
			if (delta < -3) return 'is-negative'
			return 'is-neutral'

		},

		barClass: function(rate) {

			if (rate >= 50) return 'is-winning'
			return 'is-losing'

		},

		onSelect: function(item) {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsGameAffinityAttribute',
				id: this.data ? this.data.id : 0,
				attrType: item.type,
				attrId: item.id,
				child: true
			})

		}

	}

}

</script>

<style scoped>

.winrate-row {
	padding: 10px 15px;
	cursor: pointer;
}

.winrate-row:nth-child(odd) {
	background-color: rgba(12, 137, 178, 0.05);
}

.winrate-row:hover {
	background-color: rgba(72, 129, 187, 0.1);
}

.winrate-row-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 2px;
}

.winrate-row-name {
	font-size: 14px;
	font-weight: 600;
	color: #333;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	min-width: 0;
}

.winrate-row-type {
	font-size: 10px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.3px;
	color: #999;
	margin-left: 6px;
}

.winrate-row-rate {
	font-size: 18px;
	font-weight: 700;
	color: #333;
	flex-shrink: 0;
	margin-left: 10px;
}

.winrate-row-meta {
	display: flex;
	gap: 8px;
	margin-bottom: 6px;
}

.winrate-row-delta {
	font-size: 12px;
	font-weight: 700;
}

.winrate-row-delta.is-positive { color: #2FC482; }
.winrate-row-delta.is-negative { color: #c0392b; }
.winrate-row-delta.is-neutral { color: #666; }

.winrate-row-record {
	font-size: 11px;
	color: #999;
}

.winrate-row-bar {
	height: 4px;
	background-color: rgba(0, 0, 0, 0.04);
	border-radius: 2px;
}

.winrate-row-bar-fill {
	height: 100%;
	border-radius: 2px;
}

.winrate-row-bar-fill.is-winning { background-color: #2FC482; }
.winrate-row-bar-fill.is-losing { background-color: #c0392b; }

</style>
